import { Download } from "lucide-react";
import { motion } from "framer-motion";

const PDF_LINKS = {
  profile: "https://fokallamps.com/profile.pdf",
  catalog: "https://fokallamps.com/catalog.pdf",
};
export const DownloadSection = ({ isDesktop, THEME }) => (
  <section
    id="download"
    style={{
      backgroundColor: "transparent",
      // padding: "100px 0",
      paddingBottom: "100px",
      // paddingLeft: isDesktop ? "280px" : "0",
      textAlign: "center",
    }}
  >
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "0 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "48px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "2px",
              backgroundColor: THEME.colors.primary,
            }}
          ></div>
          <span
            style={{
              color: THEME.colors.primary,
              fontWeight: "800",
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              fontSize: "12px",
            }}
          >
            Resources
          </span>
          <div
            style={{
              width: "40px",
              height: "2px",
              backgroundColor: THEME.colors.primary,
            }}
          ></div>
        </div>
        <h2
          style={{
            fontSize: isDesktop ? "48px" : "32px",
            fontWeight: "900",
            textTransform: "uppercase",
            color: "#09090b",
            lineHeight: 1.1,
            marginBottom: "16px",
          }}
        >
          Download Our Brochures
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#52525b",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: 1.6,
          }}
        >
          Access detailed specifications, certifications, and our complete
          product range in digital format.
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          gap: "32px",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <motion.a
          href={PDF_LINKS.profile}
          target="_blank"
          download="FOKAL_Company_Profile.pdf"
          whileHover={{ y: -5 }}
          whileTap={{ scale: 0.98 }}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#09090b",
            color: "white",
            padding: "32px",
            textDecoration: "none",
            width: isDesktop ? "400px" : "100%",
            borderRadius: "2px",
            border: "1px solid #27272a",
            cursor: "pointer",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <span
              style={{
                display: "block",
                fontSize: "12px",
                color: THEME.colors.textMuted,
                marginBottom: "8px",
                fontWeight: "600",
                letterSpacing: "0.05em",
              }}
            >
              CORPORATE OVERVIEW
            </span>
            <span
              style={{
                fontSize: "24px",
                fontWeight: "800",
                textTransform: "uppercase",
                display: "block",
              }}
            >
              Company Profile
            </span>
          </div>
          <div
            style={{
              width: "48px",
              height: "48px",
              backgroundColor: "#27272a",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            <Download size={20} />
          </div>
        </motion.a>
        <motion.a
          href={PDF_LINKS.catalog}
          target="_blank"
          download="FOKAL_Product_Catalog.pdf"
          whileHover={{ y: -5 }}
          whileTap={{ scale: 0.98 }}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: THEME.colors.primary,
            color: "white",
            padding: "32px",
            textDecoration: "none",
            width: isDesktop ? "400px" : "100%",
            borderRadius: "2px",
            cursor: "pointer",
            boxShadow: "0 10px 15px -3px rgba(220, 38, 38, 0.2)",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <span
              style={{
                display: "block",
                fontSize: "12px",
                color: "rgba(255,255,255,0.8)",
                marginBottom: "8px",
                fontWeight: "600",
                letterSpacing: "0.05em",
              }}
            >
              FULL SPECIFICATIONS
            </span>
            <span
              style={{
                fontSize: "24px",
                fontWeight: "800",
                textTransform: "uppercase",
                display: "block",
              }}
            >
              Product Catalog
            </span>
          </div>
          <div
            style={{
              width: "48px",
              height: "48px",
              backgroundColor: "rgba(0,0,0,0.2)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            <Download size={20} />
          </div>
        </motion.a>
      </div>
    </div>
  </section>
);
